import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Dialog } from 'shared/mui/Dialogs';
import { Table } from 'shared/mui/Table';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const StyledDatagrid = styled(Datagrid)(({ theme }) => ({
  '& .RaDatagrid-headerCell': {
    backgroundColor: theme.palette.background.default,
    fontWeight: 400,
  },
  '& .MuiTableCell-root': {
    padding: '9px 16px',
  },
}));

export const StyledSkeletonTable = styled(Table)(({ theme }) => ({
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.background.default,
    fontWeight: 400,
  },
  '& .MuiTableCell-root': {
    padding: '9px 16px',
  },
}));

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': { width: '1280px', maxWidth: '1280px' },
});

export const StyledBox = styled(Box)({
  maxHeight: '576px',
  overflowY: 'auto',
});
